import React from 'react';
import Dashboard from '@mui/icons-material/Dashboard';
import People from '@mui/icons-material/People';
import Public from '@mui/icons-material/Public';
import Language from '@mui/icons-material/Language';
import ShoppingBagOutlined from '@mui/icons-material/ShoppingBagOutlined';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import FilterList from '@mui/icons-material/FilterList';
import MonitorHeart from '@mui/icons-material/MonitorHeart';
import Settings from '@mui/icons-material/Settings';
import Inventory2 from '@mui/icons-material/Inventory2';
import Receipt from '@mui/icons-material/Receipt';
import PersonOutline from '@mui/icons-material/PersonOutline';
import { RAIL_ITEM_PERMISSION_MAP } from '../../constants/adminPermissions';

export type RailItem = {
  id: string;
  label: string;
  tooltip?: string;
  path: string;
  icon: React.ReactNode;
  badge?: number;
  section?: 'main' | 'bottom';
};

const ALL_ADMIN_RAIL_ITEMS: RailItem[] = [
  { id: 'home', label: 'Home', path: '/dashboard', icon: <Dashboard />, section: 'main' },
  { id: 'placements', label: 'Orders', path: '/guest-blog-placements', icon: <ShoppingBagOutlined />, section: 'main' },
  { id: 'clients', label: 'Clients', path: '/clients', icon: <People />, section: 'main' },
  { id: 'projects', label: 'Projects', path: '/projects', icon: <FolderOutlined />, section: 'main' },
  { id: 'sites', label: 'Sites', tooltip: 'Guest Blog Sites', path: '/sites', icon: <Language />, section: 'main' },
  { id: 'planning', label: 'Planning', path: '/planning', icon: <FilterList />, section: 'main' },
  { id: 'monitoring', label: 'Backlink Health', path: '/live-link-status', icon: <MonitorHeart />, section: 'main' },
  { id: 'publishers', label: 'Publishers', path: '/publishers', icon: <Public />, section: 'main' },
  { id: 'settings', label: 'Settings', path: '/settings', icon: <Settings />, section: 'bottom' },
];

export function buildAdminRailItems(options: {
  pendingSitesCount?: number;
  pendingPriceCount?: number;
  hasPermission: (key: string) => boolean;
}): RailItem[] {
  return ALL_ADMIN_RAIL_ITEMS.filter((item) => {
    const permKey = RAIL_ITEM_PERMISSION_MAP[item.id];
    if (!permKey) return true;
    return options.hasPermission(permKey);
  });
}

export function buildAgencyRailItems(): RailItem[] {
  return [
    { id: 'home', label: 'Home', path: '/dashboard', icon: <Dashboard />, section: 'main' },
    { id: 'placements', label: 'Orders', path: '/guest-blog-placements', icon: <ShoppingBagOutlined />, section: 'main' },
    { id: 'monitoring', label: 'Backlink Health', path: '/live-link-status', icon: <MonitorHeart />, section: 'main' },
    { id: 'clients', label: 'Clients', path: '/clients', icon: <People />, section: 'main' },
    { id: 'billing', label: 'Billing', path: '/invoices', icon: <Receipt />, section: 'main' },
    { id: 'archive', label: 'Archive', tooltip: 'Restore archived items', path: '/archive', icon: <Inventory2 />, section: 'main' },
    { id: 'profile', label: 'Profile', path: '/profile', icon: <PersonOutline />, section: 'bottom' },
  ];
}

export function buildClientRailItems(options: {
  guestBlogArrivedCount?: number;
  navLocked?: boolean;
}): RailItem[] {
  return [
    { id: 'home', label: 'Home', path: '/dashboard', icon: <Dashboard />, section: 'main' },
    { id: 'placements', label: 'Orders', path: '/guest-blog-placements', icon: <ShoppingBagOutlined />, section: 'main' },
    { id: 'monitoring', label: 'Backlink Health', path: '/live-link-status', icon: <MonitorHeart />, section: 'main' },
    { id: 'billing', label: 'Billing', path: '/billing', icon: <Receipt />, section: 'main' },
    { id: 'archive', label: 'Archive', tooltip: 'Restore archived items', path: '/archive', icon: <Inventory2 />, section: 'main' },
    { id: 'profile', label: 'Profile', path: '/profile', icon: <PersonOutline />, section: 'bottom' },
  ];
}
